import classNames from 'classnames';
import * as React from 'react';
import { isNotNullOrUndefined } from 'Util/TypeGuards';

export interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {}

export default function Tag({ className, children, ...restProps }: TagProps) {
	return (
		<span
			className={classNames('tag', isNotNullOrUndefined(className) ? className : 'tag--primary')}
			{...restProps}
		>
			{children}
		</span>
	);
}
